import { ConfigProvider, message } from 'antd';

import Colors from 'src/common/Colors';
import { Routes } from 'src/components';

export function App() {
  const [, popupMessage] = message.useMessage();

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: Colors.main1,
          fontFamily: 'IBM Plex Sans, sans-serif',
          borderRadius: 8,
          padding: 8,
        },
      }}
    >
      {popupMessage}

      <Routes />
    </ConfigProvider>
  );
}
